import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import OuterSection from "../../Elements/OuterSection.vue";
import Chart from "../../Modules/Performance/Chart/Chart.vue";
import TableT1 from "../../Modules/Performance/Table/Table.vue";

const __default__ = {
  title: "Performance Report",
  name: "Performance",
  components: { OuterSection, Chart, TableT1 },
};
import { UseDateStore } from "../../Modules/State/Stores/DateStore";
import { UseTaxonomyHelper } from "../../Helper/Stateful/UseTaxonomyHelper";
import { UseUrlBuilder } from "../../Helper/Stateful/UseUrlBuilder";
import { UseAxiosErrorHelper } from "../../Helper/ThirdParty/UseAxiosErrorHelper";
import { UseComparisonHelper } from "../../Helper/Stateful/UseComparisonHelper";
import { UsePerformanceTableDetails } from "./Hooks/PerformanceTableDetails";
import { PerformanceTableAndChartData } from "../../Helper/Stateful/PerformanceTableAndChartData";
import { UsePerformanceTable } from "../../Modules/Performance/Table/Hooks/UsePerformanceTable";
import { UseAnnotations } from "../../Modules/Performance/Chart/Hooks/UseAnnotations";
import { UseReportSettingsStore } from "../../Modules/State/Stores/ReportSettingsStore";
import { UseProgramStore } from "../../Modules/State/Stores/ProgramStore";

import { storeToRefs } from "pinia";
import { computed, onBeforeMount, onMounted, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tableDataType = "table/single";
const chartDataType = "chart/single";

const { getDateFrom, getDateTo } = storeToRefs(UseDateStore());
const { getCurrentProgramName } = storeToRefs(UseProgramStore());
UseAxiosErrorHelper();

const { currentTaxonomyInteger, taxonomyRouteParams } = UseTaxonomyHelper();

//Get Taxonomy Level
taxonomyRouteParams();

const taxonomyField = computed(() => {
  return currentTaxonomyInteger.value < 5
    ? currentTaxonomyInteger.value
    : currentTaxonomyInteger.value - 1;
});

//Build Url
const {
  buildFullUrlBasic,
  setBasicChartUrl,
  setBasicTableUrl,
  buildAnyInitialUrl,
  setBasicTableComparisonUrl,
} = UseUrlBuilder({
  dataSet: "",
});

//Get some data?
const {
  chartData,
  tableData,
  detailTree,
  chartLoading,
  tableLoading,
  chartHeaders,
  tableHeaders,
  comparisonData,
  loadChartData,
  loadTableData,
  loadComparisonData,
  clearChartData,
  clearTableData,
  clearComparisonData,
} = PerformanceTableAndChartData();

const { loadAnnotations } = UseAnnotations();

onBeforeMount(() => {
  clearChartData();
  clearTableData();
  clearComparisonData();
});
onMounted(() => {
  init();
  const urls = buildFullUrlBasic(tableDataType, chartDataType);
  setBasicChartUrl(urls.chart);
  setBasicTableUrl(urls.table);
  loadChartData();
  loadTableData();
  loadAnnotations();
});

//Chart updates
const { getPerformanceChartInterval } = storeToRefs(UseReportSettingsStore());

watch(getPerformanceChartInterval, () => {
  setBasicChartUrl(buildAnyInitialUrl("performanceChart", chartDataType));
  loadChartData();
});
//Table Details updates
const { setOpenedDetails } = UsePerformanceTableDetails();

const { records } = UsePerformanceTable();
watch(tableData, (val) => {
  setOpenedDetails(
    `taxonomy_${currentTaxonomyInteger.value}`,
    tableData,
    detailTree
  );
  records.value = val.length;
});

//Comparing
const { comparisonDates, init } = UseComparisonHelper();
watch(comparisonDates, (val) => {
  if (val.end) {
    setBasicTableComparisonUrl(buildAnyInitialUrl("comparison", tableDataType));
    loadComparisonData();
  }
});

watch([getDateFrom, getDateTo, getCurrentProgramName], () => {
  setBasicChartUrl(buildAnyInitialUrl("performanceChart", chartDataType));
  setBasicTableUrl(buildAnyInitialUrl("performanceTable", tableDataType));
  init();
  setBasicTableComparisonUrl(buildAnyInitialUrl("comparison", tableDataType));
  clearChartData();
  clearTableData();
  clearComparisonData();
  loadChartData();
  loadTableData();
  loadComparisonData();
  loadAnnotations();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(OuterSection, { ref: "performanceTaxonomyOneSection" }, {
      default: _withCtx(() => [
        _createVNode(Chart, {
          "chart-data": _unref(chartData),
          loading: _unref(chartLoading),
          headers: _unref(chartHeaders),
          class: "box",
          id: "t1-chart"
        }, null, 8, ["chart-data", "loading", "headers"]),
        _createVNode(TableT1, {
          "table-data": _unref(tableData),
          "detail-tree": _unref(detailTree),
          "comparison-data": _unref(comparisonData),
          headers: _unref(tableHeaders),
          loading: _unref(tableLoading),
          taxonomy: `taxonomy_${_unref(taxonomyField)}`,
          class: "box"
        }, null, 8, ["table-data", "detail-tree", "comparison-data", "headers", "loading", "taxonomy"])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})